import { InjectionToken, StaticProvider } from '@angular/core';
import { FormControl } from '@angular/forms';

export const SEARCH_CONTROL = new InjectionToken<FormControl<string>>('SEARCH_CONTROL');

export const SEARCH_CONTROL_PROVIDER: StaticProvider = {
  provide: SEARCH_CONTROL,
  useValue: new FormControl(''),
};
